var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container pad-route no-print-gutters"},[_c('div',{staticClass:"box no-print-borders"},[_c('app-cake-builder')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }